module.exports = __webpack_public_path__ + "img/logo-enter.91036bab.png";